module.exports = __webpack_public_path__ + "img/corona-test-betrug.b3ea23ce.png";